import './index.css';

import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { StoreProvider } from './Store';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const container = document.getElementById('root');
const root = createRoot(container!);

const router = createBrowserRouter([{ path: '*', element: <App /> }]);

root.render(
  <StoreProvider>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <RouterProvider router={router} />
      </LocalizationProvider>
    </ThemeProvider>
  </StoreProvider>
);
